import classnames from 'classnames';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Table, TableColumn } from 'tea-component';
import { history } from 'umi';
// import { useMemoizedFn, useDebounceFn } from 'ahooks';
import { context as Context } from '@gp/components/Context';
import LogoList from '@gp/pages/StudioDashboard/StudioOverall/components/LogoList';
import { useDebounceFn } from 'ahooks';
// import CollapseableLogoList from '@gp/pages/StudioDashboard/StudioOverall/components/CollapseableLogoList';
import StudioSummaryCard from '@gp/pages/StudioDashboard/StudioOverall/Tabs/Overview/components/KeyInformationTable/components/StudioSummaryCard';
// @ts-ignore
import { MENU_ID_MAP, SLASH_G_POP } from '@gp/constants/const';
import useTableStatus from '@gp/hooks/useTableStatus';
import { getFormatNumPlus, getNumberOfDotUnit, getRoundIntegerNum } from '@gp/utils/common';

import './index.scss';

import DefauldGameIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';

// const { sortable, autotip, scrollable, pageable } = Table.addons;
const { sortable, scrollable, pageable } = Table.addons;

const getYearFlag = (year: string): string => {
  // YYYY格式年份,所以正确数据应该是4位,不是4位 就是异常数据 返回空字符串
  if (year?.length !== 4) return '';
  return year;
};

/**
 * 计算Key Information At A Glance模块表格tbody的最大宽度，优化滚动效果，表格数据多时，页面滑动到最底部，也能看得到 表格上方的筛选器部分UI
 * @param isTableColumnWrap 表头是否折行
 * @returns 表格tbody的最大高度
 */
// const calcTBodyMaxHeight = (isTableColumnWrap: boolean): number => {
//   const studioOverallPageNode = document.querySelector('.gp-studio-overall');
//   // studio overall预览页总高度
//   let studioOverallPageHeight;
//   let heights;
//   if (!studioOverallPageNode) return 0;
//   studioOverallPageHeight = window
//     .getComputedStyle(studioOverallPageNode, null)
//     .getPropertyValue('height');
//   studioOverallPageHeight = Number.parseFloat(studioOverallPageHeight);
//   studioOverallPageHeight = Number.isNaN(studioOverallPageHeight)
//     ? 0
//     : studioOverallPageHeight;
//   // 顶部tab栏的高度
//   const tabHeight = 75;
//   // 表格顶部 卡片padding、title、筛选器 占据的总高度
//   // const filterHeight = 20 + (24 + 20) + 54;
//   const filterHeight = 0;
//   // padding留白的高度
//   const paddingHeight = 20 + 20;
//   // 表头折叠时的高度（换行）
//   const tHeaderHeight1 = 73;
//   // 表头不折叠时的高度（不换行）
//   const tHeaderHeight2 = 51;
//   heights = tabHeight + filterHeight + paddingHeight;
//   // 需要加上20px，因为没分页 有个地方会多20px的margin
//   heights = heights + 20;
//   // 表头折行时，高度为tHeaderHeight1，不折行时高度为tHeaderHeight2
//   heights = isTableColumnWrap
//     ? heights + tHeaderHeight1
//     : heights + tHeaderHeight2;
//   return studioOverallPageHeight - heights;
// };

/**
 * 计算表格纵向滚动配置的maxHeight
 * @param isTableColumnWrap 表头是否折行
 * @returns 表格纵向滚动配置的maxHeight
 */
// function useTableMaxHeight(isTableColumnWrap: boolean) {
//   const [maxHeight, setMaxHeight] = useState(0);

//   const updateMaxHeight = useMemoizedFn(() => {
//     const maxHeightTemp = calcTBodyMaxHeight(isTableColumnWrap);
//     setMaxHeight(maxHeightTemp);
//   });

//   useEffect(() => {
//     window.addEventListener('resize', updateMaxHeight, false);

//     return () => {
//       window.removeEventListener('resize', updateMaxHeight);
//     };
//   }, [updateMaxHeight]);

//   useEffect(() => {
//     updateMaxHeight();
//   }, [isTableColumnWrap]);

//   return maxHeight;
// }

const TableList: React.FC<IStudioOverallOverviewKeyInformationTableListProps> = (props) => {
  const {
    isTableInnerLoading,
    orderState,
    onOrderStateChange,
    records = [],
    categoryFormatter,
    // businessFormatter,
    currentParams,
    prevParams,
    reqError,
    onTableStatusChange,
  } = props;

  const { commonData } = useContext<IStudioOverallOverviewContext>(Context);
  // 表格是否出现纵向滚动条
  const [tableIsScroll, setTableIsScroll] = useState<boolean>(false);

  const tableStatus = useTableStatus({
    loading: isTableInnerLoading,
    error: reqError,
    dataSource: records,
    operat: (flag: 'back' | 'again') => {
      if (flag === 'back') {
        onTableStatusChange(prevParams.current);
      } else {
        onTableStatusChange(currentParams.current);
      }
    },
  });

  const pageSizeOptions = [10, 20, 30, 50, 100, 200];
  const showPageableOperation = records?.length > Math.min(...pageSizeOptions);
  const addons = useMemo(() => {
    const addons = [
      sortable({
        columns: [
          // 'category',
          // 'business_owner',
          // 'studio_name',
          'last_year_actual_gross_revenue',
          'this_year_budget_gross_revenue',
          'full_time_employee',
        ],
        value: [
          {
            by: orderState?.order_metric || '',
            order: orderState?.order || 'desc',
          },
        ],
        onChange: onOrderStateChange,
      }),
      tableStatus,
      scrollable({
        // maxHeight: 650,
        minWidth: 1102,
      }),
      pageable({
        stateTextVisible: true,
        pageCountChangingResetType: 'first',
        pageSizeVisible: showPageableOperation,
        pageIndexVisible: showPageableOperation,
        jumpVisible: showPageableOperation,
        endJumpVisible: showPageableOperation,
        pageSizeOptions,
        stateText: `${getNumberOfDotUnit(records?.length)} item${
          records?.length > 1 ? 's' : ''
        } in total`,
      }),
      /* autotip({
        loadingText: 'Loading...',
        emptyText: 'No Data',
        isLoading: isTableInnerLoading,
      }), */
    ];
    return addons;
  }, [isTableInnerLoading, orderState, onOrderStateChange, tableStatus]);

  const { run: handleGoToStudioDetailPage } = useDebounceFn(
    (payload, e, isJump = true) => {
      e?.stopPropagation();
      if (!payload?.id) return '';
      const filter = encodeURIComponent(
        JSON.stringify({
          studioId: payload?.id || '',
          studioName: payload?.name || '',
          menuFrom: MENU_ID_MAP['studio-dashboard_studio-overall'], // 用于标识左侧菜单栏当前选中高亮
        }),
      );
      const url = `${SLASH_G_POP}/Studio/PortfolioOverview/Detail?filter=${filter}`;
      if (isJump) {
        history.push(url);
      }

      return url;
    },
    { wait: 300 },
  );

  const columns: TableColumn<IStudioOverallOverviewKeyInformationTableRecord>[] = [
    {
      key: 'studio_name',
      width: 280,
      header: 'Studio',
      fixed: 'left',
      render: (cvm) => (
        <StudioSummaryCard
          id={cvm?.id}
          name={cvm?.name}
          cover={cvm?.cover}
          addr={cvm?.addr}
          nationalFlag={cvm?.nationalFlag}
          // @ts-ignore
          onClick={(e, isJump = true) => {
            return handleGoToStudioDetailPage(cvm, e, isJump);
          }}
        />
      ),
    },
    /* {
        key: 'category',
        width: 130,
        header: 'Category',
        render: (cvm) =>
          categoryFormatter?.(cvm?.category) || cvm?.category || '-',
      }, */
    {
      key: 'p_team',
      width: 150,
      header: 'P-team',
      render: (cvm) => categoryFormatter?.(cvm?.management_team) || cvm?.management_team || '-',
    },
    {
      key: 'business_owner',
      width: 150,
      header: 'BO',
      render: (cvm) => /* businessFormatter?.(cvm?.business) || */ cvm?.business || '-',
    },
    {
      key: 'last_year_actual_gross_revenue',
      // header: '22 Actual Gross Revenue($)',
      width: 174,
      header: (
        <div className="dbg-table-header-flex">
          <div className="dbg-table-header-text">
            {getYearFlag(commonData?.currentYear)} Actual Gross Revenue($)
          </div>
        </div>
      ),
      align: 'right',
      render: (cvm) => getFormatNumPlus(cvm?.revenue),
    },
    {
      key: 'this_year_budget_gross_revenue',
      // header: '23 Budget Gross Revenue($)',
      width: 174,
      header: (
        <div className="dbg-table-header-flex">
          <div className="dbg-table-header-text">
            {getYearFlag(commonData?.currentYear)} Budget Gross Revenue($)
          </div>
        </div>
      ),
      align: 'right',
      render: (cvm) => getFormatNumPlus(cvm?.revenue_budget),
    },
    {
      key: 'full_time_employee',
      width: 110,
      header: 'FTE',
      align: 'right',
      render: (cvm) => getRoundIntegerNum(cvm?.fte),
    },
    {
      key: 'project_development',
      // header: 'Key Project-In Development',
      // width: '18%',
      width: 268,
      header: (
        <div className="dbg-table-header-flex">
          <div className="dbg-table-header-text">Key Project - In Development</div>
        </div>
      ),
      render: (cvm) => {
        return cvm?.gamesInDev && cvm?.gamesInDev?.length > 0 ? (
          // <CollapseableLogoList
          //   uniqueId={`${cvm?.id}_project_development`}
          //   logos={cvm?.gamesInDev || []}
          //   defaultLogo={DefauldGameIcon}
          // />
          <LogoList
            title={'Key Project - In Development'}
            logos={cvm?.gamesInDev || []}
            defaultLogo={DefauldGameIcon}
            // getBubbleMsg={getBubbleMsg}
            // isModalShowItemDate={isModalShowItemDate}
          />
        ) : (
          '-'
        );
      },
    },
    {
      key: 'project_live',
      // header: 'Key Project-Live',
      // width: '18%',
      width: 268,
      header: 'Key Project - Live',
      render: (cvm) => {
        return cvm?.gamesInLive && cvm?.gamesInLive?.length > 0 ? (
          // <CollapseableLogoList
          //   uniqueId={`${cvm?.id}_project_live`}
          //   logos={cvm?.gamesInLive || []}
          //   defaultLogo={DefauldGameIcon}
          // />
          <LogoList
            title={'Key Project - In Development'}
            logos={cvm?.gamesInLive || []}
            defaultLogo={DefauldGameIcon}
            // @ts-ignore
            getBubbleMsg={() => {}}
            // isModalShowItemDate={isModalShowItemDate}
          />
        ) : (
          '-'
        );
      },
    },
  ];

  useEffect(() => {
    if (!isTableInnerLoading) {
      setTimeout(() => {
        const tableBody = document.querySelector('.dbg-studio-overall-table .tea-table__body');
        // @ts-ignore
        const flag = tableBody?.clientHeight < tableBody?.firstChild?.clientHeight;
        setTableIsScroll(flag);
      });
    }
  }, [isTableInnerLoading]);

  return (
    <Table
      className={classnames({
        'dbg-common-table dbg-studio-overall-table dbg-table-sticky dbh-action-state-center-table':
          true,
        'scroll-table-header': tableIsScroll,
      })}
      // verticalTop
      records={records || []}
      recordKey={(record) => record.id}
      columns={columns}
      addons={addons}
    />
  );
};

export default React.memo(TableList);
